const {CSSTransitionGroup} = require("react-transition-group");
const Form = require("app/components/forms/Form");

class ResponseForm extends Form {

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			complete: false,
			message: null,
			errors: null
		};
	}

	get baseClassName() {
		return super.baseClassName + " response-form";
	}

	get className() {
		let classList = [super.className];

		if (this.state.complete) {
			classList.push("form-complete");
		}

		return classList.join(" ");
	}

	onComplete(response) {
		this.setState({
			loading: false,
			complete: true,
			message: response.message || this.state.message
		});
	}

	renderMessageAction() {
		// ...
	}

	renderMessage() {
		return (
			<div className="response">
				<div className="message">{this.state.message}</div>
				{this.renderMessageAction()}
			</div>
		);
	}

	renderBody() {
		const form = this.state.complete ? null : this.renderForm();
		const message = this.state.complete ? this.renderMessage() : null;

		return (
			<div ref={el => this.bodyElement = el} className="form-body">
				<CSSTransitionGroup
					component="div"
					transitionName="show"
					transitionEnterTimeout={0}
					transitionLeaveTimeout={250}>
					{form}
				</CSSTransitionGroup>
				<CSSTransitionGroup
					component="div"
					transitionName="show"
					transitionEnterTimeout={250}
					transitionLeaveTimeout={0}>
					{message}
				</CSSTransitionGroup>
			</div>
		);
	}

}

module.exports = ResponseForm;